import IconDoorOpenSolid from '@/assets/icons/font_awesome/door-open-solid.svg?react';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PTIMITIVE__card } from '@/components/ui/card/UI_PTIMITIVE__card';
import { UI_PRIMITIVE__card_header } from '@/components/ui/card/card';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import i18n_page_auth from '@/locales/keys/i18n_page_auth.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { useTranslation } from 'react-i18next';

export function A_LAYOUT__email_not_verified() {
  const dispatch = use_dispatch();
  const { global_is_mobile } = use_slice_ui(['global_is_mobile']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_AUTH);

  function onClick() {
    dispatch(LOCAL__ui_set_boolean({ key: 'page_auth_show_email_is_not_verified', value: false }));
  }

  function render_content() {
    let out = <></>;

    out = (
      <>
        <span className="text-lg">{t(i18n_page_auth.email_not_verified_component.title.main)}</span>
        <span className="text-center">{t(i18n_page_auth.email_not_verified_component.title.text1)}</span>
        <span className="text-center">{t(i18n_page_auth.email_not_verified_component.title.text2)}</span>
        <UI_PRIMITIVE__button variant={'outline-on-component'} onClick={onClick}>
          <IconDoorOpenSolid className="!w-5 !h-5" /> {t(i18n_page_auth.email_not_verified_component.button.go_to_auth_page)}
        </UI_PRIMITIVE__button>
      </>
    );

    return out;
  }

  function render_view() {
    let out = <></>;

    if (global_is_mobile) {
      out = <div className="flex-center flex-col gap-10 px-8  pb-8  size-full text-bar-foreground">{render_content()}</div>;
    } else {
      out = (
        <UI_PTIMITIVE__card className="w-[23rem] h-[20.75rem] bg-component border-component-border flex-center text-bar-foreground">
          <UI_PRIMITIVE__card_header className="px-16 pt-6 pb-8  flex-center gap-5">{render_content()}</UI_PRIMITIVE__card_header>
        </UI_PTIMITIVE__card>
      );
    }

    return out;
  }

  return render_view();
}
